import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.js";
export const globalMiddleware = [
  validate,
  auth_45global
]
export const namedMiddleware = {}